import { render, staticRenderFns } from "./FAQ.vue?vue&type=template&id=ad459472&scoped=true"
import script from "./FAQ.vue?vue&type=script&lang=ts&setup=true"
export * from "./FAQ.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./FAQ.vue?vue&type=style&index=0&id=ad459472&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad459472",
  null
  
)

export default component.exports